import React from "react";
import SearchableSelect from "../../../modules/SearchableSelect";
import SessionStore from "../../../stores/SessionStore";
import { DEFAULT_LDAP_USER_SEARCH_FILTER } from "../../../constants/LdapConstants";
import { Link as RouterLink } from "react-router";

import { SyncStatus } from "./SyncStatus";
import { Box, Button, InlineNotification, Link, Text, Checkbox } from "@familyzone/component-library";
import { Alert, AlertIcon, AlertTitle, AlertDescription, Flex } from "@chakra-ui/react";
import { MergeOptionsNoControl, UserMergeKey } from "./ConfigForm/MergeOptions";
import PageTitle from "../../title/PageTitle";
import { ConfigFormLabel } from "./ConfigForm/ConfigFormLabel";
import { purgeSyncData } from "../../../utils/api/Purge";
import { PurgeConfirmModal } from "./ConfigForm/PurgeConfirmModal";
import { executeSync, extractSyncError, getSyncByType, SyncType } from "../../../utils/api/SyncApi";
import { mapNodeToLdapServer, saveLegacyLdap } from "./ldapSyncMapper";
import { buildMergeConfig, mergeKeyFromConfig } from "./googleAzureSyncMapper";

export default class LdapConfiguration extends React.Component {
  constructor(props, context) {
    super(props, context);
    const manuallySetRunningSyncs = JSON.parse(localStorage.getItem("manuallySetRunningSyncs") || "{}");
    const device = SessionStore.getSelectedDevice();
    this.state = {
      enabled: false,
      sync_enabled: false,
      sync_ous: false,
      sync_by_dn: false,
      type: "",
      hostname: "",
      port: "",
      basedn: "",
      ldapusername: "",
      ldappassword: "",
      search_query: DEFAULT_LDAP_USER_SEARCH_FILTER,
      userownedgroupmembership: false,
      usernameattribute: "",
      managerattribute: "",
      emailattribute: "",
      userbase: "",
      usergroupattribute: "",
      userdnattribute: "",
      groupdnattribute: "",
      oudnattribute: "",
      ounameattribute: "",
      authenticateuserusingsupplieddn: false,
      groupbase: "",
      groupnameattribute: "",
      groupmembernameattribute: "",
      loaded: false,
      saving: false,
      changes: true,
      device: device,
      lockout: manuallySetRunningSyncs[device.concat("_LDAPLockout")],
      user_merge_key: UserMergeKey.Email,
      user_merge_priority: 50,
      user_merge_attach_only: false,
      error: "",
      showPurgeModal: false,
      isPurging: false,
    };

    this.handle_load();
  }

  notifyChanged = () => {
    this.setState({ changes: true });
  };

  handle_ChangeEnabled = (event) => {
    this.notifyChanged();
    this.setState({
      enabled: event.target.checked,
    });
  };

  handle_ChangeSync = (event) => {
    this.notifyChanged();
    this.setState({
      sync_enabled: event.target.checked,
    });
  };

  handle_ChangeSyncOUs = (event) => {
    this.setState({
      sync_ous: event.target.checked,
      changed: true,
    });
  };

  handle_ChangeSyncByDN = (event) => {
    this.setState({
      sync_by_dn: event.target.checked,
      changed: true,
    });
  };

  handle_ChangeAuthenticateUserUsingDn = (event) => {
    this.notifyChanged();
    this.setState({
      authenticateuserusingsupplieddn: event.target.checked,
    });
  };

  handle_ChangeMode = (event) => {
    this.notifyChanged();
    this.setState({
      type: event.value,
    });
  };

  handle_ChangeUserOwnedGroupMembership = (event) => {
    this.notifyChanged();
    this.setState({
      userownedgroupmembership: event.target.checked,
    });
  };

  handle_ChangeUserNameAttribute = (event) => {
    this.notifyChanged();
    this.setState({
      usernameattribute: event.target.value,
    });
  };

  handle_ChangeManagerAttribute = (event) => {
    this.notifyChanged();
    this.setState({
      managerattribute: event.target.value,
    });
  };

  handle_ChangeEmailAttribute = (event) => {
    this.notifyChanged();
    this.setState({
      emailattribute: event.target.value,
    });
  };

  handle_ChangeUserBase = (event) => {
    this.notifyChanged();
    this.setState({
      userbase: event.target.value,
    });
  };

  handle_ChangeUserGroupAttribute = (event) => {
    this.notifyChanged();
    this.setState({
      usergroupattribute: event.target.value,
    });
  };

  handle_ChangeUserDnAttribute = (event) => {
    this.notifyChanged();
    this.setState({
      userdnattribute: event.target.value,
    });
  };

  handle_ChangeGroupDnAttribute = (event) => {
    this.notifyChanged();
    this.setState({
      groupdnattribute: event.target.value,
    });
  };

  handle_ChangeOuDnAttribute = (event) => {
    this.notifyChanged();
    this.setState({
      oudnattribute: event.target.value,
    });
  };

  handle_ChangeOuNameAttribute = (event) => {
    this.notifyChanged();
    this.setState({
      ounameattribute: event.target.value,
    });
  };

  handle_ChangeGroupBase = (event) => {
    this.notifyChanged();
    this.setState({
      groupbase: event.target.value,
    });
  };

  handle_ChangeGroupNameAttribute = (event) => {
    this.notifyChanged();
    this.setState({
      groupnameattribute: event.target.value,
    });
  };

  handle_ChangeGroupMemberNameAttribute = (event) => {
    this.notifyChanged();
    this.setState({
      groupmembernameattribute: event.target.value,
    });
  };

  handle_ChangeUserMergeKey = (value) => {
    this.notifyChanged();
    this.setState({
      user_merge_key: value,
    });
  };

  handle_ChangeUserMergeExpression = (value) => {
    this.notifyChanged();
    this.setState({
      user_merge_expression: value,
    });
  };

  handle_ChangeUserMergeAttachOnly = (value) => {
    this.notifyChanged();
    this.setState({
      user_merge_attach_only: value,
    });
  };

  handle_ChangeUserMergePriority = (value) => {
    this.notifyChanged();

    // Accept empty string or digits only
    if (value === "" || /^[0-9]+$/.test(value)) {
      // Convert to number only for validation purposes
      const numValue = value === "" ? "" : parseInt(value, 10);

      // Allow any intermediate valid input (digits only)
      // For empty or numbers within range 1-99
      if (value === "" || (numValue >= 1 && numValue <= 99)) {
        this.setState({
          user_merge_priority: Number(value),
        });
      }
    }
  };

  handle_Purge = () => {
    this.setState({
      showPurgeModal: true,
    });
  };

  handle_PurgeConfirm = async () => {
    this.setState({ isPurging: true });
    try {
      const device = SessionStore.getSelectedDevice();
      await purgeSyncData("00000000-0000-0000-0000-000000000000", device);
      this.setState({ showPurgeModal: false });
      this.handle_load();
      alert("Purge triggered successfully");
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "An unknown error occurred while trying to purge data.";
      alert(`Failed to trigger purge: ${errorMessage}`);
    } finally {
      this.setState({ isPurging: false });
    }
  };

  handle_ChangeHostname = (event) => {
    this.notifyChanged();
    this.setState({
      hostname: event.target.value,
    });
  };

  handle_ChangePort = (event) => {
    this.notifyChanged();
    const port = parseInt(event.target.value);
    if (!isNaN(port)) {
      this.setState({
        port: parseInt(event.target.value),
      });
    } else {
      this.setState({ port: "" });
    }
  };
  handle_ChangeBaseDN = (event) => {
    this.notifyChanged();
    this.setState({
      basedn: event.target.value,
    });
  };
  handle_ChangeUsername = (event) => {
    this.notifyChanged();
    this.setState({
      ldapusername: event.target.value,
    });
  };
  handle_ChangePassword = (event) => {
    this.notifyChanged();
    this.setState({
      ldappassword: event.target.value,
    });
  };
  handle_ChangeSearchQuery = (event) => {
    let value = event.target.value ? event.target.value : DEFAULT_LDAP_USER_SEARCH_FILTER;
    this.setState({
      search_query: value,
      changed: true,
    });
  };

  handle_load = () => {
    let self = this;
    // sync-api serves the legacy configuration only once it is configured, so a
    // missing node means the form starts from its defaults and the first save creates it.
    getSyncByType(SyncType.Ldap)
      .then((node) => {
        if (!node) {
          // sync-api requires a server type and port on create; these are its defaults.
          self.setState({ loaded: true, sync_id: undefined, is_running: false, type: "ad", port: 389 });
          return;
        }
        const configuration = mapNodeToLdapServer(node);
        const mergeConfig = configuration.merge_config;
        self.setState({
          enabled: configuration.enabled,
          sync_enabled: configuration.sync_enabled,
          sync_ous: configuration.sync_ous,
          sync_by_dn: configuration.sync_by_dn,
          type: configuration.type,
          hostname: configuration.hostname,
          port: configuration.port,
          basedn: configuration.basedn,
          ldapusername: configuration.ldapusername,
          ldappassword: configuration.ldappassword || "",
          search_query: configuration.search_query || DEFAULT_LDAP_USER_SEARCH_FILTER,
          userownedgroupmembership: configuration.userownedgroupmembership,
          usernameattribute: configuration.usernameattribute,
          managerattribute: configuration.managerattribute,
          userbase: configuration.userbase,
          usergroupattribute: configuration.usergroupattribute,
          userdnattribute: configuration.userdnattribute,
          groupdnattribute: configuration.groupdnattribute,
          oudnattribute: configuration.oudnattribute,
          ounameattribute: configuration.ounameattribute,
          authenticateuserusingsupplieddn: configuration.authenticateuserusingsupplieddn,
          groupbase: configuration.groupbase,
          groupnameattribute: configuration.groupnameattribute,
          groupmembernameattribute: configuration.groupmembernameattribute,
          emailattribute: configuration.emailattribute,
          sync_id: node.id,
          is_running: node.sync.isRunning,
          loaded: true,
          // for defaults we set email not stripped and priority 50
          user_merge_priority: mergeConfig?.priority || 50,
          user_merge_expression: mergeConfig?.computed?.expression || undefined,
          user_merge_key: mergeKeyFromConfig(mergeConfig),
          user_merge_attach_only: mergeConfig?.attachOnly || false,
        });
      })
      .catch((e) => {
        self.setState({ loaded: true, error: extractSyncError(e, "Error loading the LDAP configuration.") });
      });
  };

  handle_Submit = (event) => {
    event.preventDefault();

    if (
      this.state.user_merge_priority === "" ||
      isNaN(this.state.user_merge_priority) ||
      this.state.user_merge_priority < 1 ||
      this.state.user_merge_priority > 99
    ) {
      this.setState({
        error: "Please enter a valid priority between 1 and 99.",
      });
      return;
    }

    if (
      this.state.user_merge_key === UserMergeKey.Computed &&
      (this.state.user_merge_expression === undefined || this.state.user_merge_expression === "")
    ) {
      this.setState({
        error: "An expression is required if Merge Key is Computed Expression.",
      });
      return;
    }

    let self = this;

    const mergeConfig = buildMergeConfig(
      this.state.user_merge_priority,
      this.state.user_merge_key,
      this.state.user_merge_expression,
      this.state.user_merge_attach_only
    );

    let object = {
      enabled: this.state.enabled,
      sync_enabled: this.state.sync_enabled,
      sync_ous: this.state.sync_ous,
      sync_by_dn: this.state.sync_by_dn,
      type: this.state.type,
      hostname: this.state.hostname,
      port: this.state.port,
      basedn: this.state.basedn,
      ldapusername: this.state.ldapusername,
      ldappassword: this.state.ldappassword,
      search_query: this.state.search_query,
      userownedgroupmembership: this.state.userownedgroupmembership,
      usernameattribute: this.state.usernameattribute,
      managerattribute: this.state.managerattribute,
      userbase: this.state.userbase,
      usergroupattribute: this.state.usergroupattribute,
      userdnattribute: this.state.userdnattribute,
      groupdnattribute: this.state.groupdnattribute,
      oudnattribute: this.state.oudnattribute,
      ounameattribute: this.state.ounameattribute,
      authenticateuserusingsupplieddn: this.state.authenticateuserusingsupplieddn,
      groupbase: this.state.groupbase,
      groupnameattribute: this.state.groupnameattribute,
      groupmembernameattribute: this.state.groupmembernameattribute,
      emailattribute: this.state.emailattribute,
    };

    self.setState({ changes: false, saving: true, error: "" });

    saveLegacyLdap(object, mergeConfig, this.state.sync_id)
      .then(() => {
        self.handle_load();
        self.setState({ saving: false });
      })
      .catch((e) => {
        self.setState({ saving: false, error: extractSyncError(e, "Error attempting to save the LDAP configuration.") });
      });
  };

  handle_Sync = () => {
    let self = this;
    if (self.state.sync_id && !self.state.is_running) {
      self.setState({ loaded: false, is_running: true });

      executeSync(self.state.sync_id)
        .then(() => {
          self.handle_load();
          const manuallySetRunningSyncs = JSON.parse(localStorage.getItem("manuallySetRunningSyncs") || "{}");
          const now = new Date();
          manuallySetRunningSyncs[self.state.device.concat("_LDAPLockout")] = now.getTime() + 60000; // 60 second 'ttl' to lock out this sync in this browser
          localStorage.setItem("manuallySetRunningSyncs", JSON.stringify(manuallySetRunningSyncs));
        })
        .catch(() => self.handle_load());
    }
  };

  render__RequiredOptions = () => {
    return (
      <div>
        <div className="formgroup-element">
          <div className="formgroup-element-title">Enabled</div>
          <div className="formgroup-element-fields">
            <div className="mui-checkbox">
              <Flex alignItems="center">
                <Flex>
                  <Checkbox
                    name="enabled"
                    isChecked={this.state.enabled}
                    onChange={this.handle_ChangeEnabled}
                    aria-label="Enabled"
                    data-cy="enabled"
                  />
                </Flex>
              </Flex>
            </div>
          </div>
        </div>

        {this.render_GeneralOptions()}
      </div>
    );
  };

  render_GeneralOptions = () => {
    if (!this.state.enabled) {
      return <div />;
    }

    return (
      <div>
        <div className="formgroup-element">
          <div className="formgroup-element-title">Sync Enabled</div>
          <div className="formgroup-element-fields">
            <div className="mui-checkbox">
              <Flex alignItems="center">
                <Flex>
                  <Checkbox
                    name="syncEnabled"
                    isChecked={this.state.sync_enabled}
                    onChange={this.handle_ChangeSync}
                    aria-label="Sync Enabled"
                    data-cy="syncEnabled"
                  />
                </Flex>
              </Flex>
            </div>
          </div>
        </div>
        <div className="formgroup-element">
          <div className="formgroup-element-title">Sync Organization Units</div>
          <div className="formgroup-element-fields">
            <div className="mui-checkbox">
              <Flex alignItems="center">
                <Flex>
                  <Checkbox
                    name="syncOrgUnits"
                    isChecked={this.state.sync_ous}
                    onChange={this.handle_ChangeSyncOUs}
                    aria-label="Sync Organization Units"
                    data-cy="syncOrgUnits"
                  />
                </Flex>
              </Flex>
            </div>
          </div>
        </div>
        <div className="formgroup-element">
          <div className="formgroup-element-title">Server Type</div>
          <div className="formgroup-element-fields">
            <div className="formgroup-element-fields-inline">
              <div className="server-type-search">
                <SearchableSelect
                  value={this.state.type}
                  clearable={false}
                  className={"server-type-search"}
                  onChange={this.handle_ChangeMode}
                  valueDataMap={[
                    ["ad", "Active Directory"],
                    ["ol", "OpenLdap"],
                    ["ed", "Novell eDirectory"],
                    ["custom", "Manual"],
                  ]}
                  data-cy="serverType"
                ></SearchableSelect>
              </div>
            </div>
          </div>
        </div>

        <div className="formgroup-element">
          <div className="formgroup-element-title">Server Hostname</div>
          <div className="formgroup-element-fields">
            <div className="formgroup-element-fields-inline">
              <div className="mui-textfield">
                <input type="text" value={this.state.hostname} onChange={this.handle_ChangeHostname} data-cy="serverHostname" />
              </div>
            </div>
          </div>
        </div>
        <div className="formgroup-element">
          <div className="formgroup-element-title">Server Port</div>
          <div className="formgroup-element-fields">
            <div className="formgroup-element-fields-inline">
              <div className="mui-textfield">
                <input type="text" value={this.state.port} onChange={this.handle_ChangePort} data-cy="serverPort" />
              </div>
            </div>
          </div>
        </div>
        <div className="formgroup-element">
          <div className="formgroup-element-title">Base DN</div>
          <div className="formgroup-element-fields">
            <div className="formgroup-element-fields-inline">
              <div className="mui-textfield">
                <input type="text" value={this.state.basedn} onChange={this.handle_ChangeBaseDN} data-cy="baseDN" />
              </div>
            </div>
          </div>
        </div>
        <div className="formgroup-element">
          <div className="formgroup-element-title">Username</div>
          <div className="formgroup-element-fields">
            <div className="formgroup-element-fields-inline">
              <div className="mui-textfield">
                <input type="text" value={this.state.ldapusername} onChange={this.handle_ChangeUsername} data-cy="username" />
              </div>
            </div>
          </div>
        </div>
        <div className="formgroup-element">
          <div className="formgroup-element-title">Password</div>
          <div className="formgroup-element-fields">
            <div className="formgroup-element-fields-inline">
              <div className="mui-textfield">
                <input type="text" value={this.state.ldappassword} onChange={this.handle_ChangePassword} data-cy="password" />
                {/* We use text instead of password as input-type because the ldap-password has been obfuscated by the back-end.
                            It looks like *****1q2w*/}
              </div>
            </div>
          </div>
        </div>
        <hr />
        <ConfigFormLabel
          label={"Search Query"}
          tooltip={"This default filter excludes computer accounts and disabled users to sync only active user accounts."}
        />
        <div className="mui-textfield">
          <input type="text" value={this.state.search_query} onChange={this.handle_ChangeSearchQuery} data-cy="searchQuery" />
        </div>
        <div className="formgroup-element">
          <em>
            <div>Syncing by DN allows you to sync multiple groups with the same name.</div>
            <div>Changing this can invalidate existing filtering rules.</div>
          </em>
          <div className="formgroup-element-title">Sync By DN</div>
          <div className="formgroup-element-fields">
            <div className="mui-checkbox">
              <Flex alignItems="center">
                <Flex>
                  <Checkbox
                    name="syncByDN"
                    isChecked={this.state.sync_by_dn}
                    onChange={this.handle_ChangeSyncByDN}
                    aria-label="Sync By DN"
                    data-cy="syncByDN"
                  />
                </Flex>
              </Flex>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render__ManualOptions = () => {
    if (this.state.type === "custom") {
      return (
        <div>
          <div className="formgroup-element">
            <div className="formgroup-element-title"> User Owned Group Membership</div>
            <div className="formgroup-element-fields">
              <div className="mui-checkbox">
                <Flex alignItems="center">
                  <Flex>
                    <Checkbox
                      name="userOwnedGroupMembership"
                      isChecked={this.state.userownedgroupmembership}
                      onChange={this.handle_ChangeUserOwnedGroupMembership}
                      aria-label="User Owned Group Membership"
                    />
                  </Flex>
                </Flex>
              </div>
            </div>
          </div>
          <div className="formgroup-element">
            <div className="formgroup-element-title"> Username Attribute</div>
            <div className="formgroup-element-fields">
              <div className="formgroup-element-fields-inline">
                <div className="mui-textfield">
                  <input type="text" value={this.state.usernameattribute} onChange={this.handle_ChangeUserNameAttribute} />
                </div>
              </div>
            </div>
          </div>
          <div className="formgroup-element">
            <div className="formgroup-element-title"> Manager Attribute</div>
            <div className="formgroup-element-fields">
              <div className="formgroup-element-fields-inline">
                <div className="mui-textfield">
                  <input type="text" value={this.state.managerattribute} onChange={this.handle_ChangeManagerAttribute} />
                </div>
              </div>
            </div>
          </div>
          <div className="formgroup-element">
            <div className="formgroup-element-title">Email Attribute</div>
            <div className="formgroup-element-fields">
              <div className="formgroup-element-fields-inline">
                <div className="mui-textfield">
                  <input type="text" value={this.state.emailattribute} onChange={this.handle_ChangeEmailAttribute} />
                </div>
              </div>
            </div>
          </div>
          <div className="formgroup-element">
            <div className="formgroup-element-title"> User Base</div>
            <div className="formgroup-element-fields">
              <div className="formgroup-element-fields-inline">
                <div className="mui-textfield">
                  <input type="text" value={this.state.userbase} onChange={this.handle_ChangeUserBase} />
                </div>
              </div>
            </div>
          </div>
          <div className="formgroup-element">
            <div className="formgroup-element-title"> User Group Attribute</div>
            <div className="formgroup-element-fields">
              <div className="formgroup-element-fields-inline">
                <div className="mui-textfield">
                  <input type="text" value={this.state.usergroupattribute} onChange={this.handle_ChangeUserGroupAttribute} />
                </div>
              </div>
            </div>
          </div>
          <div className="formgroup-element">
            <div className="formgroup-element-title"> User DN Attribute</div>
            <div className="formgroup-element-fields">
              <div className="formgroup-element-fields-inline">
                <div className="mui-textfield">
                  <input type="text" value={this.state.userdnattribute} onChange={this.handle_ChangeUserDnAttribute} />
                </div>
              </div>
            </div>
          </div>
          <div className="formgroup-element">
            <div className="formgroup-element-title"> Group DN Attribute</div>
            <div className="formgroup-element-fields">
              <div className="formgroup-element-fields-inline">
                <div className="mui-textfield">
                  <input type="text" value={this.state.groupdnattribute} onChange={this.handle_ChangeGroupDnAttribute} />
                </div>
              </div>
            </div>
          </div>
          <div className="formgroup-element">
            <div className="formgroup-element-title"> OU DN Attribute</div>
            <div className="formgroup-element-fields">
              <div className="formgroup-element-fields-inline">
                <div className="mui-textfield">
                  <input type="text" value={this.state.oudnattribute} onChange={this.handle_ChangeOuDnAttribute} />
                </div>
              </div>
            </div>
          </div>
          <div className="formgroup-element">
            <div className="formgroup-element-title"> OU Name Attribute</div>
            <div className="formgroup-element-fields">
              <div className="formgroup-element-fields-inline">
                <div className="mui-textfield">
                  <input type="text" value={this.state.ounameattribute} onChange={this.handle_ChangeOuNameAttribute} />
                </div>
              </div>
            </div>
          </div>
          <div className="formgroup-element">
            <div className="formgroup-element-title"> Authenticate with User DN</div>
            <div className="formgroup-element-fields">
              <div className="mui-checkbox">
                <Flex alignItems="center">
                  <Flex>
                    <Checkbox
                      name="authenticateUserUsingDn"
                      isChecked={this.state.authenticateuserusingsupplieddn}
                      onChange={this.handle_ChangeAuthenticateUserUsingDn}
                      aria-label="Authenticate with User DN"
                    />
                  </Flex>
                </Flex>
              </div>
            </div>
          </div>
          <div className="formgroup-element">
            <div className="formgroup-element-title"> Group Base</div>
            <div className="formgroup-element-fields">
              <div className="formgroup-element-fields-inline">
                <div className="mui-textfield">
                  <input type="text" value={this.state.groupbase} onChange={this.handle_ChangeGroupBase} />
                </div>
              </div>
            </div>
          </div>
          <div className="formgroup-element">
            <div className="formgroup-element-title">Group Name Attribute</div>
            <div className="formgroup-element-fields">
              <div className="formgroup-element-fields-inline">
                <div className="mui-textfield">
                  <input type="text" value={this.state.groupnameattribute} onChange={this.handle_ChangeGroupNameAttribute} />
                </div>
              </div>
            </div>
          </div>

          <div className="formgroup-element">
            <div className="formgroup-element-title">Group Member Name Attribute</div>
            <div className="formgroup-element-fields">
              <div className="formgroup-element-fields-inline">
                <div className="mui-textfield">
                  <input type="text" value={this.state.groupmembernameattribute} onChange={this.handle_ChangeGroupMemberNameAttribute} />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return <div />;
  };

  render__AdvanceOptions = () => {
    if (!this.state.enabled) {
      return <div />;
    }

    return (
      <Box>
        <hr />
        <MergeOptionsNoControl
          priorityValue={this.state.user_merge_priority}
          onPriorityChange={this.handle_ChangeUserMergePriority}
          mergeKeyValue={this.state.user_merge_key}
          onMergeKeyChange={this.handle_ChangeUserMergeKey}
          expression={this.state.user_merge_expression}
          onExpressionChange={this.handle_ChangeUserMergeExpression}
          attachOnly={this.state.user_merge_attach_only}
          onAttachOnlyChange={this.handle_ChangeUserMergeAttachOnly}
        />
      </Box>
    );
  };

  render() {
    return (
      <>
        <Alert status="warning" variant="warning" px={20} position="fixed" zIndex={10}>
          <AlertIcon />
          <AlertTitle>Legacy Screen - </AlertTitle>
          <AlertDescription>
            &nbsp;Please migrate to the&nbsp;
            <Link as={RouterLink} to="/config/device/authentication/servers">
              LDAP Servers screen
            </Link>
            &nbsp;for all current and future configurations.
          </AlertDescription>
        </Alert>
        <Box display={"flex"} flex={1} padding={"24px"} gap={"16px"} mt={25}>
          <PageTitle title="LDAP" />
          <Box flex={1} minWidth={"500px"}>
            <Box background={"white"} display={"flex"} flexDir={"column"} gap={"1rem"} padding={"1rem"} borderRadius={"6px"}>
              <Box
                borderBottom={"1px solid #e2e2e2"}
                padding={"20px"}
                display={"flex"}
                flexDir={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Box display={"flex"} flexDir={"column"} gap={"1rem"}>
                  <Text fontSize={"24px"}>LDAP</Text>
                  <Link isExternal href={"https://help.linewize.com/hc/en-gb/articles/5732871324444"}>
                    Configuring LDAP Integration Guide
                  </Link>
                </Box>
                {SessionStore.getState().isSupportAdmin() && (
                  <Button variant="danger" onClick={this.handle_Purge} data-cy="purge-btn">
                    Purge Data
                  </Button>
                )}
              </Box>
              <Box>
                <form className="mui-form">
                  <div className="formgroup">
                    <div className="formgroup-content">
                      {this.render__RequiredOptions()}
                      {this.render__ManualOptions()}
                      {this.render__AdvanceOptions()}
                    </div>
                  </div>
                </form>
              </Box>
              <Box padding={"24px"} background={"#F5FCFF"}>
                {this.state.error !== "" && (
                  <InlineNotification status="warning" notificationTitle={"Unable to save"} notificationDescription={this.state.error} />
                )}
                <Button onClick={this.handle_Submit} disabled={!this.state.changes || this.state.saving} variant="primary">
                  Save
                </Button>
              </Box>
            </Box>
          </Box>
          {this.state.enabled && this.state.sync_id && (
            <Box width={"500px"} gap={"16px"} display={"flex"} flexDir={"column"}>
              <SyncStatus
                handleRunSync={this.handle_Sync}
                syncLockoutTime={
                  JSON.parse(localStorage.getItem("manuallySetRunningSyncs") || "{}")[this.state.device.concat("_LDAPLockout")]
                    ? JSON.parse(localStorage.getItem("manuallySetRunningSyncs") || "{}")[this.state.device.concat("_LDAPLockout")]
                    : undefined
                }
                syncType={"LDAPS"}
                syncId={this.state.sync_id}
              />
            </Box>
          )}
        </Box>
        <PurgeConfirmModal
          description="All synced data associated with this sync configuration and with LDAP servers (if they exist) will be permanently deleted. This includes users, groups, classrooms, schools, guardians and any associations."
          isOpen={this.state.showPurgeModal}
          onClose={() => this.setState({ showPurgeModal: false })}
          onConfirm={() => void this.handle_PurgeConfirm()}
          isLoading={this.state.isPurging}
        />
      </>
    );
  }
}
